export default {
  header: 2,
  nav: 10,
  navClickLayer: 9,
  backgroundImageLayer: -2,
  backgroundGradientLayer: -1,
};
